import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

* {
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

*:focus {
  outline: 0;
}

html,
body,
#root {
  height: 100%;
  background-color: #111;
}

body,
input,
textarea,
button,
h1, h2, h3, h4, h5, h6, p, span, a {
  font-family: "Roboto Slab", sans-serif;
  font-size: 16px;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
}

button, a {
  cursor: pointer;
}
`;
